/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Badge} from 'react-bootstrap';
import {API_PROJECT_LEADS, API_TEAM_PROJECT_EMPLOYEE_PERIODS, API_TEAM_PROJECT_EMPLOYEE_REVIEW} from '../../const/Api';
import {ALERT_VARIANT, EConsolidationStatus, EPathname, PaginationEnum, REVIEW_TYPE} from '../../const/dataEnum';
import {setAlert} from '../../stores/actions/alertModalStateAction';
import {useLocation} from 'react-router-dom/cjs/react-router-dom.min';
import {FmlxButton, FmlxIcon} from 'fmlx-common-ui';
import {FMLX_BUTTON, FMLX_COMPONENT} from '../../const/FmlxComponentEnum';
import './Consolidation.scss';
import {getConfig} from '../../stores/business/appBusiness';
import {setPageNo, setPageSize} from '../../stores/actions/manageEmployeeAction';
import {setConsolidationStatus, setCurrentPeriodId} from '../../stores/actions/appStateAction';
import EssSimpleTable from '../../components/MessageTable/TableColumn/EssSimpleTable';
import {callAPI} from '../../api/rest/callApi';

export default function Consolidation() {
  const dispatch = useDispatch();
  const {user, currentPeriodId, pageNo, pageSize, consolidationStatus} = useSelector((state) => ({
    user: state.appState.user,
    currentPeriodId: state.appState.currentPeriod.id,
    pageNo: state.manageEmployeeState?.pageNo ?? 0,
    pageSize: state.manageEmployeeState?.pageSize ?? 10,
    consolidationStatus: state.appState.consolidationStatus,
  }));

  const [loadingProject, setLoadingProject] = useState(true);
  const [projectList, setProjectList] = useState([]);
  const [periodList, setPeriodList] = useState([]);
  const [projectId, setProjectId] = useState('');
  const [loadingPeriod, setLoadingPeriod] = useState(true);
  const [sortMapState, setSortMapState] = useState({type: 'asc', column: 'name'});
  const [filterMapState, setFilterMapState] = useState(null);
  const [listData, setListData] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [pageCountState, setPageCountState] = useState(1);
  const [configState, setConfigState] = useState(null);
  const [totalItem, setTotalItem] = useState(0);
  const history = useHistory();
  const location = useLocation();
  const pageSizes = PaginationEnum.PAGE_OPTIONS;
  const [openRows, setOpenRows] = useState({});
  const [columnFilters, setColumnFilters] = useState({});
  const isFirstRender = useRef(true);
  const nameFilterRef = useRef(null);
  const statusFilterRef = useRef(null);

  useEffect(() => {
    fetchProject();
    (async () => {
      const config = await getConfig();
      setConfigState(config);
    })();
  }, []);

  useEffect(() => {
    let timer = null;
    if (projectId && currentPeriodId && configState) {
      if (pageNo < 0 || isNaN(pageNo)) {
        dispatch(setPageNo(0));
        return;
      }

      timer = setTimeout(() => {
        populateData();
      }, [configState.debounceDelay]);
    }

    if (isFirstRender.current && location.state) {
      isFirstRender.current = false;

      if (location.state?.pageNo !== undefined) {
        dispatch(setPageNo(location.state.pageNo));
      }

      if (location.state?.pageSize !== undefined) {
        dispatch(setPageSize(location.state.pageSize));
      }

      if (location.state?.lastPageCount !== undefined) {
        setPageCountState(location.state.lastPageCount);
      }

      if (location.state?.lastTotalItems !== undefined) {
        setTotalItem(location.state.lastTotalItems);
      }

      if (location.state?.savedFilterMapState) {
        setFilterMapState(location.state.savedFilterMapState);
      }

      if (location.state?.savedFilterMapState) {
        setFilterMapState(location.state.savedFilterMapState);
        dispatch(setConsolidationStatus(location.state.savedFilterMapState.consolidationstatus));
      }

      history.replace({...location, state: undefined});
    }

    if (consolidationStatus && (!filterMapState || filterMapState.consolidationstatus !== consolidationStatus)) {
      setFilterMapState((prev) => ({...prev, consolidationstatus: consolidationStatus}));
    }
    if (location.state?.periodID) {
      dispatch(
        setCurrentPeriodId({
          id: location.state.periodID,
          periode: location.state.periodString,
          isActive: false,
        })
      );
    }

    return () => {
      clearTimeout(timer);
    };
  }, [
    projectId,
    currentPeriodId,
    filterMapState,
    sortMapState,
    pageNo,
    pageSize,
    consolidationStatus,
    configState,
    dispatch,
    history,
  ]);

  const fetchProject = () => {
    const projectID = location?.state?.projectID;
    setLoadingProject(true);
    callAPI({
      method: 'GET',
      url: API_PROJECT_LEADS,
    })
      .then((response) => {
        const {data, message, responseCode} = response.data;

        // Sort the list of projects by their names
        let sortData = data.sort((a, b) => {
          return a.projectName > b.projectName ? 1 : a.projectName < b.projectName ? -1 : 0;
        });
        setProjectList(sortData);
        let initialSelectedProjectId = sortData[0].id;
        if (!projectID) {
          if (sortData.length > 0) {
            setProjectId(initialSelectedProjectId);
            fetchPeriod(initialSelectedProjectId);
          }
        } else {
          setProjectId(projectID);
          fetchPeriod(projectID);
        }
        callError(response.data);
      })
      .catch((error) => {
        // dispatch(setAlert({ show: true, variant: ALERT_VARIANT.ERROR, message: error.data }));
      })
      .finally(() => {
        setLoadingProject(false);
      });
  };

  const fetchPeriod = (projectId) => {
    setLoadingPeriod(true);
    callAPI({
      method: 'GET',
      url: API_TEAM_PROJECT_EMPLOYEE_PERIODS.replace('{PROJECT_ID}', projectId),
    })
      .then((response) => {
        const {data, message, responseCode} = response.data;
        setPeriodList(data);

        if (!callError(response.data)) {
          let initialSelectedPeriod = data.find((period) => period.isActive === true);
          if (initialSelectedPeriod === undefined) initialSelectedPeriod = data[data.length - 1];
        }
      })
      .catch((error) => {
        // dispatch(setAlert({ show: true, variant: ALERT_VARIANT.ERROR, message: error.data }));
      })
      .finally(() => {
        setLoadingPeriod(false);
      });
  };

  const populateData = () => {
    if (!projectId || !currentPeriodId) {
      return;
    }
    
    setLoadingData(true);
    const getApiConsolidationStatus = (status) => {
      if (status === null || status === undefined || status === '') {
        return null;
      }

      if (status === EConsolidationStatus.ALL) {
        return null;
      }

      if (status === 'Not Yet' || status === 'Done' || status === 'Done And Locked') {
        return status;
      }

      switch (status) {
        case EConsolidationStatus.NOT_YET:
          return 'Not Yet';
        case EConsolidationStatus.DONE:
          return 'Done';
        case EConsolidationStatus.DONE_AND_LOCKED:
          return 'Done And Locked';
        default:
          return status;
      }
    };

    const consolidationStatusValue = filterMapState?.consolidationstatus;
    const apiConsolidationStatus = getApiConsolidationStatus(consolidationStatusValue);
    callAPI({
      method: 'GET',
      url: API_TEAM_PROJECT_EMPLOYEE_REVIEW.replace('{PROJECT_ID}', projectId).replace('{PERIOD_ID}', currentPeriodId),
      params: {
        fullname: filterMapState?.name || null,
        consolidationstatus: apiConsolidationStatus,
        sortBy: sortMapState.column,
        sortType: sortMapState.type,
        pageNo: Number(pageNo || 0) + 1,
        pageSize: Number(pageSize || 10),
      },
    })
      .then((response) => {
        const {data, message, totalCount, responseCode} = response.data;
        let isManager = '';
        let isProjectLead = false;
        let projectLedName = '';
        if (responseCode === 0) {
          const processedData = data?.map((item) => {
            let consolidationStatus = 'Not Yet';
            if (item.employee.reviewsForMe.length !== 0 && item.employee.reviewsForMe[0].reviewDate !== null) {
              const isReleased = item.employee.reviewsForMe.some((r) => r.released);
              if (isReleased) {
                consolidationStatus = 'Done And Locked';
              } else {
                const isConsolidated = item.employee.reviewsForMe.some((r) => r.reviewTypeID === REVIEW_TYPE.CONS.Id);
                if (isConsolidated) {
                  consolidationStatus = 'Done';
                }
              }
            }

            return {...item, consolidationStatus};
          });

          let filteredData = processedData;
          if (filterMapState?.consolidationstatus && filterMapState.consolidationstatus !== EConsolidationStatus.ALL) {
            filteredData = processedData.filter((item) => {
              const itemStatus = removeWhitespace(item.consolidationStatus);
              const filterStatus = removeWhitespace(filterMapState.consolidationstatus);

              return itemStatus === filterStatus;
            });
          }

          setListData(filteredData || []);
          const filteredCount = filteredData.length;
          setTotalItem(
            filterMapState?.consolidationstatus && filterMapState.consolidationstatus !== EConsolidationStatus.ALL
              ? filteredCount
              : totalCount
          );
          const pageCount = Math.ceil(
            (filterMapState?.consolidationstatus && filterMapState.consolidationstatus !== EConsolidationStatus.ALL
              ? filteredCount
              : totalCount) / pageSize
          );
          setPageCountState(pageCount);

          filteredData?.forEach((v, i) => {
            if (v.employee.practiceID !== user.practice.id) {
              isProjectLead = true;
              projectLedName = v.project.projectName;
            }
          });
        } else {
          setListData([]);
        }
      })
      .catch((error) => {
        // dispatch(setAlert({ show: true, variant: ALERT_VARIANT.ERROR, message: error.data }));
      })
      .finally(() => {
        setLoadingData(false);
      });
  };

  function callError(result) {
    if (result.responseCode !== 0) {
      dispatch(setAlert({show: true, variant: ALERT_VARIANT.ERROR, message: result.message}));
      return true;
    }

    return false;
  }

  const setConsolidation = (employeeId, locked) => {
    history.push({
      pathname: EPathname.CONSOLIDATION_REVIEW,
      state: {
        employeeId,
        currentPeriodId,
        projectId,
        pageNo,
        pageSize,
        lastTotalItems: totalItem,
        lastPageCount: pageCountState,
        savedFilterMapState: filterMapState,
      },
    });
  };

  const generateConsolidationStatus = (reviews) => {
    if (reviews.length !== 0 && reviews[0].reviewDate !== null) {
      const isReleased = reviews.some((r) => r.released);
      if (isReleased) return <Badge bg="success">Done & Locked</Badge>;

      const isConsolidated = reviews.some((r) => r.reviewTypeID === REVIEW_TYPE.CONS.Id);
      if (isConsolidated) return <Badge bg="success">Done</Badge>;
    }

    return <Badge bg="secondary">Not Yet</Badge>;
  };

  const removeWhitespace = (text) => {
    if (text) {
      return text.replace(/\s+/g, '').toLowerCase();
    }

    return null;
  };

  const columnTable = {
    name: (row) => row.employee.fullName,
    practice: (row) => row.employee.practice.practiceName,
    role: (row) => row.teamRole,
    reviewStatus: (row) => `${row.employee.totalReviewComplete} of ${row.employee.totalReviewer}`,
    consolidationStatus: (row) => generateConsolidationStatus(row.employee.reviewsForMe),
    action: (row) => {
      const employeeId = row.employeeID;
      const released = row?.employee?.reviewsForMe[0]?.released;

      return (
        <div style={{whiteSpace: 'nowrap'}}>
          <FmlxButton
            size={FMLX_COMPONENT.SIZE.M}
            variant={FMLX_BUTTON.VARIANT.OUTLINE}
            label="View"
            onClick={() => {
              let locked = released ? true : false;
              setConsolidation(employeeId, locked);
            }}
            withIcon={FMLX_BUTTON.WITH_ICON.END}
            icon={<FmlxIcon name={'Eye'} />}
          ></FmlxButton>
        </div>
      );
    },
  };

  function renderColumnTable(column, row) {
    const render = columnTable[column.accessor];
    return render ? render(row) : '';
  }

  function handleSortFilter(column) {
    const type = sortMapState.type === 'asc' ? 'desc' : 'asc';
    setSortMapState({type, column});
  }

  function handleCollapse(rowId) {
    setOpenRows((prevState) => ({
      ...prevState,
      [rowId]: !prevState[rowId],
    }));
  }

  function handleNameFilter(e) {
    const searchValue = e?.value ?? e?.target?.value ?? e ?? '';
    setColumnFilters((prev) => ({...prev, name: searchValue}));
    setFilterMapState((prev) => ({...prev, name: searchValue}));

    if (!searchValue) {
      setTimeout(() => {
        populateData();
      }, 50);
    }
  }

  function handleConsoldiationStatusFilter(e) {
    const statusValue = e?.target?.value || e || '';
    setColumnFilters((prev) => ({...prev, consolidationStatus: statusValue}));
    setFilterMapState((prev) => ({...prev, consolidationstatus: statusValue}));
    dispatch(setConsolidationStatus(statusValue));
  }

  function handleDropdownFilter(event, key) {
    if (key.toLowerCase() === 'consolidationstatus') {
      const originalValue = typeof event === 'object' ? event.text || event.value || event.id || '' : event;
      let valueToUse = originalValue;

      if (typeof originalValue === 'number') {
        switch (originalValue) {
          case 0:
            valueToUse = EConsolidationStatus.ALL;
            break;
          case 1:
            valueToUse = EConsolidationStatus.NOT_YET;
            break;
          case 2:
            valueToUse = EConsolidationStatus.DONE;
            break;
          case 3:
            valueToUse = EConsolidationStatus.DONE_AND_LOCKED;
            break;
          default:
            valueToUse = EConsolidationStatus.ALL;
            break;
        }
      }
      dispatch(setConsolidationStatus(valueToUse));
      setFilterMapState({...filterMapState, consolidationstatus: valueToUse});
    } else {
      setFilterMapState((prev) => ({...prev, [key]: event}));
    }
  }

  const listDatas = [
    {
      id: 1,
      accessor: 'name',
      Header: 'Name',
      sortable: true,
      filter: 'TEXT',
      size: 'lg',
    },
    {
      id: 2,
      accessor: 'practice',
      Header: 'Practice',
      sortable: false,
    },
    {
      id: 3,
      accessor: 'role',
      Header: 'Role',
      sortable: false,
    },
    {
      id: 4,
      accessor: 'reviewStatus',
      Header: 'Review Status',
      sortable: false,
    },
    {
      id: 5,
      accessor: 'consolidationStatus',
      Header: 'Consolidation Status',
      sortable: false,
      filter: 'DROPDOWN',
      items: [
        {id: 0, text: EConsolidationStatus.ALL, group: 'default', disabled: false},
        {id: 1, text: EConsolidationStatus.NOT_YET, group: 'default', disabled: false},
        {id: 2, text: EConsolidationStatus.DONE, group: 'default', disabled: false},
        {id: 3, text: EConsolidationStatus.DONE_AND_LOCKED, group: 'default', disabled: false},
      ],
    },
    {
      id: 6,
      accessor: 'action',
      Header: 'Action',
      sortable: false,
    },
  ];

  const handleChangePage = (event, newPage) => {
    const parsedPage = Number(newPage);
    if (!isNaN(parsedPage)) {
      dispatch(setPageNo(parsedPage));
    }
  };

  const handleChangeRowPerPage = (e) => {
    const newPageSize = parseInt(e.target.value, 10);
    if (!isNaN(newPageSize)) {
      const startIndex = pageNo * pageSize;
      const newPageNo = Math.floor(startIndex / newPageSize);
      dispatch(setPageSize(newPageSize));
      dispatch(setPageNo(newPageNo));
    }
  };

  const select_project_period = (
    <div className="row mb-4">
      <div className="col-md-6 col-lg-6 col-sm-12">
        <div className="row g-3">
          <div className="col-5">
            <label htmlFor="selectProject" className="label">
              Project
            </label>
            <select
              id="selectProject"
              className="form-select"
              aria-label="Select Project"
              value={projectId === null ? '' : projectId}
              onChange={(e) => {
                setProjectId(e.target.value);
                fetchPeriod(e.target.value);
                dispatch(setConsolidationStatus(null));
                dispatch(setPageNo(0));
                dispatch(setPageSize(pageSizes[0]));
                setFilterMapState((prevState) => {
                  const newFilterMap = {...prevState};
                  if (newFilterMap.consolidationstatus) {
                    delete newFilterMap.consolidationstatus;
                  }

                  return newFilterMap;
                });
              }}
            >
              {projectList?.map((per) => (
                <option key={per.id} value={per.id}>
                  {per.projectName}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="col-12" />
    </div>
  );

  const getDropdownIndex = (accessor, value) => {
    if (accessor === 'consolidationStatus') {
      const items = [
        EConsolidationStatus.ALL,
        EConsolidationStatus.NOT_YET,
        EConsolidationStatus.DONE,
        EConsolidationStatus.DONE_AND_LOCKED,
      ];
      return items.findIndex((item) => item === value);
    }
    return -1;
  };

  return (
    <div className="container">
      {select_project_period}
      <div className="consolidation-table-container">
        <EssSimpleTable
          columnFilterSelectedIndex={{
            consolidationStatus: getDropdownIndex('consolidationStatus', filterMapState?.consolidationstatus),
          }}
          columns={renderColumnTable}
          onSort={handleSortFilter}
          onCollapse={handleCollapse}
          openRows={openRows}
          classNameBy=""
          columnFilterRefs={{
            name: nameFilterRef,
            consolidationStatus: statusFilterRef,
          }}
          columnFilterHandlers={{
            name: handleNameFilter,
            consolidationStatus: handleConsoldiationStatusFilter,
            dropdown: handleDropdownFilter,
          }}
          filteredData={listData}
          collapsibleContentTable={(row) => null}
          columnData={listDatas}
          dataCount={{length: totalItem}}
          rowsPerPage={pageSize}
          page={pageNo}
          onChangePage={(e, newPage) => handleChangePage(e, newPage)}
          onChangeRowsPerPage={handleChangeRowPerPage}
          onPageOption={pageSizes}
          targetValue=""
          hideHeader={false}
          hideFooter={false}
          emptyRowHeight={50}
          onEmptyDataShow={loadingData ? 'Loading data...' : 'Data not found'}
        />
      </div>
      {/* {tabel(listData, loadingData)} */}
    </div>
  );
}
